<template>
  <div class="modal fade" id="imageadd" role="dialog">
    <div class="modal-dialog" :class="size">
      <div class="modal-content">
        <div class="modal-body">
          <div class="flexbox">
            <div class="col-sm-12">
              <image-input
                :option="this.option"
                :asin="this.asin"
                :shareLink="this.shareLink"
                @close="$emit('close')"
                @refresh="$emit('refresh')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageInput from '@/components/ImageInput'
export default {
  components: {
    ImageInput
  },
  props: {
    asin: {
      type: String,
      default: ''
    },
    shareLink: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'modal-xl'
    }
  },
  computed: {
    option () {
      return {
        url: `${process.env.NODE_SERVER_API}Product/judge-image`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
        thumbnailWidth: 150,
        maxFilesize: 150,
        addRemoveLinks: true,
        autoProcessQueue: false,
        uploadMultiple: true,
        dictDefaultMessage: '審査に必要なファイルを、ここにドラッグ＆ドロップ<br><br><button class="btn btn-info w-200">またはファイルを選択</button>'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewImageAdd.vue